/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ProductInstanceCertificate } from '../models/product-instance-certificate';
@Injectable({
  providedIn: 'root',
})
class CertificateService extends __BaseService {
  static readonly CertificateCreateProductCerificatePath = '/api/Certificate/CreateProductCerificate';
  static readonly CertificateReplaceProductCerificatePath = '/api/Certificate/ReplaceProductCerificate';
  static readonly CertificateGetCertificatesByProductInstanceIdPath = '/api/Certificate/GetCertificatesByProductInstanceId';
  static readonly CertificateGetCertificateByIdPath = '/api/Certificate/GetCertificateById';
  static readonly CertificateUpdateCertificatePath = '/api/Certificate/UpdateCertificate';
  static readonly CertificateDeleteCertificateByIdPath = '/api/Certificate/DeleteCertificateById';
  static readonly CertificateInsertFilePath = '/api/Certificate/InsertFile';
  static readonly CertificateRetrieveFilePath = '/api/Certificate/RetrieveFile/{certificateId}';
  static readonly CertificateGetFilePath = '/api/Certificate/GetFile/{uri}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `CertificateService.CertificateCreateProductCerificateParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `productInstanceId`:
   */
  CertificateCreateProductCerificateResponse(params: CertificateService.CertificateCreateProductCerificateParams): __Observable<__StrictHttpResponse<ProductInstanceCertificate>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.model;
    if (params.productInstanceId != null) __params = __params.set('productInstanceId', params.productInstanceId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Certificate/CreateProductCerificate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstanceCertificate>;
      })
    );
  }
  /**
   * @param params The `CertificateService.CertificateCreateProductCerificateParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `productInstanceId`:
   */
  CertificateCreateProductCerificate(params: CertificateService.CertificateCreateProductCerificateParams): __Observable<ProductInstanceCertificate> {
    return this.CertificateCreateProductCerificateResponse(params).pipe(
      __map(_r => _r.body as ProductInstanceCertificate)
    );
  }

  /**
   * @param params The `CertificateService.CertificateReplaceProductCerificateParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `existingCertificateId`:
   */
  CertificateReplaceProductCerificateResponse(params: CertificateService.CertificateReplaceProductCerificateParams): __Observable<__StrictHttpResponse<ProductInstanceCertificate>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.model;
    if (params.existingCertificateId != null) __params = __params.set('existingCertificateId', params.existingCertificateId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Certificate/ReplaceProductCerificate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstanceCertificate>;
      })
    );
  }
  /**
   * @param params The `CertificateService.CertificateReplaceProductCerificateParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `existingCertificateId`:
   */
  CertificateReplaceProductCerificate(params: CertificateService.CertificateReplaceProductCerificateParams): __Observable<ProductInstanceCertificate> {
    return this.CertificateReplaceProductCerificateResponse(params).pipe(
      __map(_r => _r.body as ProductInstanceCertificate)
    );
  }

  /**
   * @param params The `CertificateService.CertificateGetCertificatesByProductInstanceIdParams` containing the following parameters:
   *
   * - `productInstanceId`:
   *
   * - `customerId`:
   */
  CertificateGetCertificatesByProductInstanceIdResponse(params: CertificateService.CertificateGetCertificatesByProductInstanceIdParams): __Observable<__StrictHttpResponse<Array<ProductInstanceCertificate>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.productInstanceId != null) __params = __params.set('productInstanceId', params.productInstanceId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Certificate/GetCertificatesByProductInstanceId`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ProductInstanceCertificate>>;
      })
    );
  }
  /**
   * @param params The `CertificateService.CertificateGetCertificatesByProductInstanceIdParams` containing the following parameters:
   *
   * - `productInstanceId`:
   *
   * - `customerId`:
   */
  CertificateGetCertificatesByProductInstanceId(params: CertificateService.CertificateGetCertificatesByProductInstanceIdParams): __Observable<Array<ProductInstanceCertificate>> {
    return this.CertificateGetCertificatesByProductInstanceIdResponse(params).pipe(
      __map(_r => _r.body as Array<ProductInstanceCertificate>)
    );
  }

  /**
   * @param params The `CertificateService.CertificateGetCertificateByIdParams` containing the following parameters:
   *
   * - `productInstanceId`:
   *
   * - `customerId`:
   *
   * - `certificateId`:
   */
  CertificateGetCertificateByIdResponse(params: CertificateService.CertificateGetCertificateByIdParams): __Observable<__StrictHttpResponse<ProductInstanceCertificate>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.productInstanceId != null) __params = __params.set('productInstanceId', params.productInstanceId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    if (params.certificateId != null) __params = __params.set('certificateId', params.certificateId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Certificate/GetCertificateById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstanceCertificate>;
      })
    );
  }
  /**
   * @param params The `CertificateService.CertificateGetCertificateByIdParams` containing the following parameters:
   *
   * - `productInstanceId`:
   *
   * - `customerId`:
   *
   * - `certificateId`:
   */
  CertificateGetCertificateById(params: CertificateService.CertificateGetCertificateByIdParams): __Observable<ProductInstanceCertificate> {
    return this.CertificateGetCertificateByIdResponse(params).pipe(
      __map(_r => _r.body as ProductInstanceCertificate)
    );
  }

  /**
   * @param model undefined
   */
  CertificateUpdateCertificateResponse(model: ProductInstanceCertificate): __Observable<__StrictHttpResponse<ProductInstanceCertificate>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/Certificate/UpdateCertificate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstanceCertificate>;
      })
    );
  }
  /**
   * @param model undefined
   */
  CertificateUpdateCertificate(model: ProductInstanceCertificate): __Observable<ProductInstanceCertificate> {
    return this.CertificateUpdateCertificateResponse(model).pipe(
      __map(_r => _r.body as ProductInstanceCertificate)
    );
  }

  /**
   * @param certificateId undefined
   */
  CertificateDeleteCertificateByIdResponse(certificateId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (certificateId != null) __params = __params.set('certificateId', certificateId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/Certificate/DeleteCertificateById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param certificateId undefined
   */
  CertificateDeleteCertificateById(certificateId?: number): __Observable<Blob> {
    return this.CertificateDeleteCertificateByIdResponse(certificateId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `CertificateService.CertificateInsertFileParams` containing the following parameters:
   *
   * - `certificateId`:
   *
   * - `asset`:
   */
  CertificateInsertFileResponse(params: CertificateService.CertificateInsertFileParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.certificateId != null) __params = __params.set('certificateId', params.certificateId.toString());
    if (params.asset != null) { __formData.append('asset', params.asset as unknown as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/Certificate/InsertFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `CertificateService.CertificateInsertFileParams` containing the following parameters:
   *
   * - `certificateId`:
   *
   * - `asset`:
   */
  CertificateInsertFile(params: CertificateService.CertificateInsertFileParams): __Observable<boolean> {
    return this.CertificateInsertFileResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param certificateId undefined
   */
  CertificateRetrieveFileResponse(certificateId: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Certificate/RetrieveFile/${encodeURIComponent(String(certificateId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param certificateId undefined
   */
  CertificateRetrieveFile(certificateId: number): __Observable<Blob> {
    return this.CertificateRetrieveFileResponse(certificateId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param uri undefined
   */
  CertificateGetFileResponse(uri: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/Certificate/GetFile/${encodeURIComponent(String(uri))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param uri undefined
   */
  CertificateGetFile(uri: string): __Observable<Blob> {
    return this.CertificateGetFileResponse(uri).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module CertificateService {

  /**
   * Parameters for CertificateCreateProductCerificate
   */
  export interface CertificateCreateProductCerificateParams {
    model: ProductInstanceCertificate;
    productInstanceId?: number;
  }

  /**
   * Parameters for CertificateReplaceProductCerificate
   */
  export interface CertificateReplaceProductCerificateParams {
    model: ProductInstanceCertificate;
    existingCertificateId?: number;
  }

  /**
   * Parameters for CertificateGetCertificatesByProductInstanceId
   */
  export interface CertificateGetCertificatesByProductInstanceIdParams {
    productInstanceId?: number;
    customerId?: number;
  }

  /**
   * Parameters for CertificateGetCertificateById
   */
  export interface CertificateGetCertificateByIdParams {
    productInstanceId?: number;
    customerId?: number;
    certificateId?: number;
  }

  /**
   * Parameters for CertificateInsertFile
   */
  export interface CertificateInsertFileParams {
    certificateId?: number;
    asset?: null | Blob;
  }
}

export { CertificateService }
